import type { EtapaDaSafra } from "@base/contracts";
import { EstadoVazio } from "@base/ui";
import { formatar } from "../../dashboard";
import { rotuloDaEtapa } from "./textos";

/** Largura da etapa em relação à maior quantidade do funil. */
export function larguraDaEtapa(quantidade: number, topo: number): number {
  if (topo <= 0 || quantidade <= 0) return 0;
  const razao = (quantidade / topo) * 100;
  if (!Number.isFinite(razao)) return 0;
  return Math.min(100, Math.max(0, razao));
}

/** Funil em barras horizontais: quantidade e a passagem que já veio no contrato. */
export function FunilDaSafra({ etapas }: { readonly etapas: readonly EtapaDaSafra[] }) {
  if (etapas.length === 0) {
    return <EstadoVazio titulo="Sem safra neste período." descricao="Ainda não há etapas de passagem." />;
  }
  const topo = Math.max(...etapas.map((etapa) => etapa.quantidade));
  return (
    <ol className="flex flex-col gap-2.5 text-sm">
      {etapas.map((etapa) => {
        const largura = larguraDaEtapa(etapa.quantidade, topo);
        const passagem = etapa.percentual === null ? null : formatar.porcentagem(etapa.percentual);
        return (
          <li key={etapa.nome} className="flex min-w-0 flex-col gap-1">
            <div className="flex justify-between gap-texto">
              <span className="min-w-0 break-words text-foreground">
                {rotuloDaEtapa(etapa.nome)}
                {passagem ? (
                  <span className="text-muted-foreground">
                    {" · "}
                    <span>{passagem}</span>
                  </span>
                ) : null}
              </span>
              <span className="shrink-0 font-bold tabular-nums text-foreground">{formatar.quantidade(etapa.quantidade)}</span>
            </div>
            <div
              role="meter"
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={Math.round(largura)}
              aria-label={`${rotuloDaEtapa(etapa.nome)}: ${formatar.quantidade(etapa.quantidade)}, passagem ${passagem ?? "—"}`}
              className="h-2 w-full overflow-hidden rounded-full bg-muted"
            >
              <div
                className="h-full rounded-full bg-primary motion-safe:transition-[width] motion-safe:duration-300"
                style={{ width: `${largura}%` }}
              />
            </div>
          </li>
        );
      })}
    </ol>
  );
}
